import React from 'react';
import { Alert, Card, Descriptions, Space } from 'antd';
import { TDataset } from '../../../models/aibuilder/aibuilder';
import DatasetDiagnosticsPanel from './DatasetDiagnosticsPanel';

export interface DeliverStationProps {
  dataset: TDataset;
  purpose: string;
}

export const AI_BUILDER_PASS_MARK = 70;

const DeliverStation: React.FC<DeliverStationProps> = ({ dataset, purpose }) => {
  const latest = [...(dataset.models || [])].sort((a, b) => b.version - a.version)[0];
  const ready = latest?.accuracy != null && latest.accuracy >= AI_BUILDER_PASS_MARK;
  const isText = dataset.data_type === 'text';

  return (
    <Card title="Résumé de mon IA">
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Descriptions column={1}>
          <Descriptions.Item label="Dataset">{dataset.name}</Descriptions.Item>
          <Descriptions.Item label="Nombre de labels">{dataset.labels?.length || 0}</Descriptions.Item>
          <Descriptions.Item label={isText ? 'Phrases incluses' : 'Images incluses'}>
            {(dataset.samples || []).filter((sample) => !sample.excluded).length}
          </Descriptions.Item>
          <Descriptions.Item label="Intention">{purpose || '—'}</Descriptions.Item>
          <Descriptions.Item label="Précision">
            {latest ? (latest.accuracy != null ? `${latest.accuracy}%` : '—') : 'Pas encore entraîné'}
          </Descriptions.Item>
        </Descriptions>
        <Alert
          type={ready ? 'success' : 'warning'}
          showIcon
          message={ready ? (
            <span>
              Ton IA est prête à être livrée ! Utilise le bouton <strong>Soummettre</strong> en haut de la page.
            </span>
          ) : (
            <span>
              Il faut au moins {AI_BUILDER_PASS_MARK}% de précision avant de livrer.
              {' '}Retourne à l'étape <strong>Entraîner</strong> ou <strong>Améliorer</strong>.
            </span>
          )}
        />
        <DatasetDiagnosticsPanel dataset={dataset} accuracy={latest?.accuracy ?? null} />
      </Space>
    </Card>
  );
};

export default DeliverStation;
